import { render, staticRenderFns } from "./AnalyticalReportConfig.vue?vue&type=template&id=b5aa454e&scoped=true"
import script from "./AnalyticalReportConfig.vue?vue&type=script&lang=js"
export * from "./AnalyticalReportConfig.vue?vue&type=script&lang=js"
import style0 from "./AnalyticalReportConfig.vue?vue&type=style&index=0&id=b5aa454e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5aa454e",
  null
  
)

export default component.exports